import {
  PlayerType,
  Token,
  UserAgent,
  UserToken,
  AmazonBillingInfo,
  Entitlement,
} from "@blacknut/javascript-sdk/dist";
import {
  GameLaunchOptions,
  WebRTCStopReason,
} from "@blacknut/playerwebrtc-sdk/dist/model";
import { Dispatch } from "redux";
export declare type PlayOpts = {
  game: string;
  player: PlayerType;
  env?: string;
  tokens: Token;
  launchOptions: GameLaunchOptions;
};

export declare type FullScreenChangeListener = (fullscreen: boolean) => void;
export const ERROR_CODE_TIMEOUT = "TIMEOUT";

export interface NativeModule {
  tearDown?: () => void;

  setStartUrl: (url: string) => void;

  requestFullscreen?: () => Promise<void>;
  exitFullscreen?: () => Promise<void>;

  /** @deprecated since https://blacknut.atlassian.net/browse/CA-3824, FB is responsible to select proper player  */
  availablePlayers?: () => Promise<{ label: string; value: string }[]>;
  /** @deprecated since https://blacknut.atlassian.net/browse/CA-3824, FB is responsible to select proper player  */
  setPlayer?: (s: string | undefined) => Promise<void>;
  /** @deprecated since https://blacknut.atlassian.net/browse/CA-3824, FB is responsible to select proper player  */
  getPlayer?(): Promise<string>;
  getDeviceInfo?(): Promise<UserAgent>;
  play?(opts: PlayOpts): Promise<WebRTCStopReason | undefined>;
  getAppVersion?(): Promise<string>;

  addFullcreenChangeListener?: (callback: FullScreenChangeListener) => void;
  removeFullscreenChangeListener?: (callback: FullScreenChangeListener) => void;
  isFullscreen?: () => Promise<boolean>;
  exit?: () => void;

  setUserToken?: (token: Token | undefined) => Promise<void>;
  setFamilyToken?: (token: Token | undefined) => Promise<void>;

  /**
   *
   * @returns true if native module handles in app web rtc (false for LudoRTC)
   */
  handleInAppWebRTC: () => boolean;

  getPlayerVersion?: (type: string) => Promise<string>;

  //////////
  //AMAZON
  //////////
  canHandleInAppSignup?: () => boolean;
  handleInAppSignup?: (dispatch: Dispatch) => Promise<UserToken>;

  canHandleInAppSignin?: () => boolean;
  handleInAppSignin?: (dispatch?: Dispatch) => Promise<UserToken | void>;

  canHandleInAppSubscribe?: () => Promise<boolean>;
  handleInAppSubscribe?: (
    dispatch: Dispatch,
    migrateAmazonPay?: boolean,
  ) => Promise<Entitlement[]>;

  ///////////
  // AIS
  ///////////
  canHandleAISOnboarding?: () => Promise<boolean>;
  handleAISOnboarding?: () => void;

  checkForUpdates?: () => void;

  getDefaultTheme?: () => Promise<string | undefined>;

  getReferrer?: () => Promise<string>;

  getInstallReferrer?: () => Promise<string>;

  getAmazonBillingInfo?: () => Promise<AmazonBillingInfo>;

  /**
   * @returns true if onClick should be prefered instead on onOPressEnter
   */
  removeOnPressEnter?: () => Promise<boolean>;
}
